module.exports = "/_next/static/images/Collection@2x-8f346fafa456f5d72bcfa1fb94154e73.png";